import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'label', 'idleIcon', 'copiedIcon']
  static values = { copiedText: String }

  copy(_event) {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(this.contentTarget.value)
    } else {
      // Fallback des contextes non sécurisés : execCommand exige une sélection.
      this.contentTarget.select()
      this.contentTarget.setSelectionRange(0, 99999) // pour le tactile
      document.execCommand('copy')
      this.contentTarget.setSelectionRange(0, 0)
      this.contentTarget.blur()
    }
    this.#confirm()
  }

  // Retour visible un instant : le libellé du bouton devient « Lien copié ! »
  // (desktop) et la pastille troque sa copie contre une coche (mobile).
  #confirm() {
    if (this.hasLabelTarget && this.copiedTextValue) {
      this.originalLabel ??= this.labelTarget.textContent
      this.labelTarget.textContent = this.copiedTextValue
    }
    if (this.hasIdleIconTarget && this.hasCopiedIconTarget) {
      this.idleIconTarget.classList.add('hidden')
      this.copiedIconTarget.classList.remove('hidden')
    }

    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => {
      if (this.hasLabelTarget && this.originalLabel) this.labelTarget.textContent = this.originalLabel
      if (this.hasIdleIconTarget && this.hasCopiedIconTarget) {
        this.idleIconTarget.classList.remove('hidden')
        this.copiedIconTarget.classList.add('hidden')
      }
    }, 1600)
  }
}
